/* The Band — hero: colour swatches drive the band image (shared colour store). */
(function () {
  function apply(root, c) {
    if (!c) return;
    root.querySelectorAll('[data-band-stack] img').forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-key') === c.key); });
    root.querySelectorAll('[data-pick]').forEach(function (b) {
      var on = b.getAttribute('data-pick') === c.key;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var n = root.querySelector('[data-sel-name]'), no = root.querySelector('[data-sel-no]');
    if (n) n.textContent = c.name;
    if (no) no.textContent = c.no;
  }

  function init(root) {
    if (!root || root._bdHero) return;
    root._bdHero = true;
    var D = window.Dozzee;
    apply(root, D.getColour());
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick]');
      if (b) D.setColour(b.getAttribute('data-pick'), 'band-hero');
    });
    var on = function (e) { if (document.body.contains(root)) apply(root, e.detail && e.detail.colour); else document.removeEventListener('dozzee:colour', on); };
    document.addEventListener('dozzee:colour', on);
  }

  function boot(scope) {
    if (!window.Dozzee || !window.Dozzee.getColour) return setTimeout(function () { boot(scope); }, 50);
    (scope || document).querySelectorAll('[data-section-type="band-hero"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
